import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { ProviderService } from "../../../services/provider.service";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },
  // TODO MOVE TO GLOBAL STYLES
  formControl: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      width: 180,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  box: {
    marginTop: "20px",
  },
}));

const ModalProviderUser = ({
  onClose,
  type,
  userSelected,
  detailAlert,
  addAlert,
  loadUsers,
}) => {
  const classes = useStyles();

  const [provider, setProvider] = React.useState({});

  useEffect(() => {
    (async function () {
      addAlert({ showAlert: false });
      try {
        console.log("id provider", userSelected[0]);
        const { data } = await ProviderService.getProviderById(userSelected[0]);
        setProvider(data);
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
        onClose();
      }
    })();
  }, []);

  const handleEditProvider = async () => {
    addAlert({ showAlert: true });
    console.log("Update provider", provider);
    try {
      const { status } = await ProviderService.updateProvider(provider);
      if (status === 201) {
        detailAlert({
          severity: "success",
          message: "Proveedor actualizado exitosamente",
        });
        loadUsers("provider");
      }
    } catch (error) {
      console.log("error UPDATE employee", error);
      detailAlert({ severity: "error", message: error.msgs });
    }
    onClose();
  };

  const handleInputText = (event) => {
    setProvider({ ...provider, [event.target.name]: event.target.value });
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={true}
        keepMounted
        onClose={onClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <ValidatorForm
            noValidate
            className={classes.form}
            method="POST"
            onSubmit={handleEditProvider}
            onError={(errors) => console.log(errors)}
          >
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
            >
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Box mb={4}>
                  <Typography
                    component={"span"}
                    variant="h5"
                    style={{ color: "#0b148e" }}
                  >
                    Editar proveedor
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}></Grid>
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Nombre
                  </Typography>
                  <TextValidator
                    className={classes.inputField}
                    name="name"
                    value={provider.name || ""}
                    validators={["required"]}
                    onChange={(e) => handleInputText(e)}
                    errorMessages={["El nombre es requerido"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 30,
                    }}
                  ></TextValidator>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Alias
                  </Typography>
                  <TextValidator
                    className={classes.inputField}
                    name="alias"
                    value={provider.alias || ""}
                    validators={["required"]}
                    onChange={(e) => handleInputText(e)}
                    errorMessages={["El alias es requerido"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Dirección
                  </Typography>
                  <TextValidator
                    className={classes.inputField}
                    name="direction"
                    value={provider.direction || ""}
                    validators={["required"]}
                    onChange={(e) => handleInputText(e)}
                    errorMessages={["La dirección es requerida"]}
                    variant="outlined"
                    inputProps={{
                      maxLength: 80,
                    }}
                  ></TextValidator>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Tiempo de garantia
                </Typography>
                <InputMask
                  mask="999"
                  maskChar=""
                  value={provider.timeGuarantee || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.inputField}
                      name="timeGuarantee"
                      validators={["required"]}
                      errorMessages={["El tiempo de garantía es requerido"]}
                      variant="outlined"
                      inputProps={{
                        maxLength: 30,
                      }}
                    />
                  )}
                </InputMask>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Clave de producto (SAT)
                  </Typography>
                  <InputMask
                    mask="9999999999"
                    maskChar=""
                    value={provider.providerCode || ""}
                    onChange={(e) => handleInputText(e)}
                  >
                    {() => (
                      <TextValidator
                        className={classes.inputField}
                        name="providerCode"
                        validators={["required"]}
                        errorMessages={["La clave de producto es requerida"]}
                        variant="outlined"
                        inputProps={{
                          maxLength: 30,
                        }}
                      />
                    )}
                  </InputMask>
                </Box>
              </Grid>
            </Grid>

            <Grid
              style={{ marginTop: 30 }}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  color="primary"
                  style={{ marginRight: 50, width: 150 }}
                  onClick={onClose}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  color="primary"
                  style={{ width: 150 }}
                  variant="contained"
                >
                  Actualizar
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ModalProviderUser);
